<div class="profile-settings-container">
  <div class="info-row">
    <div class="info-column name-column">
      <span class="label">Name</span>
      <span class="value">{{ userDisplayName }}</span>
    </div>
    <div class="info-column address-column">
      <span class="label">TIM-Adresse</span>
      <div class="value-wrapper">
        <span class="value">{{ userid }}</span>
        <button
          mat-icon-button
          (click)="copyUserId()"
          [attr.data-testid]="testIds.buttonCopyUserId"
          matTooltip="TIM-Adresse kopieren">
          <mat-icon svgIcon="copy"></mat-icon>
        </button>
      </div>
    </div>
    <div class="info-column status-column">
      <span class="value" [attr.data-testid]="testIds.presenceStatus">
        {{ (presenceStatus$ | async) === 'online' ? 'Online' : 'Offline' }}
        <mat-icon
          class="status-icon"
          [svgIcon]="(presenceStatus$ | async) === 'online' ? 'online' : 'offline'"
          [style.color]="(presenceStatus$ | async) === 'online' ? 'green' : 'grey'">
        </mat-icon>
      </span>
    </div>
  </div>

  <div class="avatar-section">
    <div class="avatar-preview">
      <div class="avatar-wrapper">
        @if (avatarFile) {
          <img class="avatar-image" [src]="getURLforFile(avatarFile)" alt="Neues Profilbild" />
        } @else if (settingsOriginator.state.settingsConfigurations.avatarIcon) {
          <img class="avatar-image" [src]="getAvatarUrl()" alt="Profilbild" />
        } @else {
          <mat-icon class="avatar-icon" svgIcon="avatar-profile-settings"></mat-icon>
        }
      </div>
    </div>
    <div class="avatar-controls">
      <div class="upload-delete-controls">
        <div
          class="upload-control"
          (click)="fileInput.click()"
          (keydown.enter)="fileInput.click()"
          [attr.data-testid]="testIds.buttonUploadProfile"
          tabindex="0">
          <mat-icon svgIcon="upload-black"></mat-icon>
          <span>hochladen</span>
        </div>
        <div
          class="delete-control"
          (click)="deleteUserAvatar()"
          (keydown.enter)="deleteUserAvatar()"
          [attr.data-testid]="testIds.buttonDeleteProfile"
          tabindex="0">
          <mat-icon svgIcon="trash-black"></mat-icon>
          <span>entfernen</span>
        </div>
      </div>
      <input
        #fileInput
        (change)="chooseAvatar($event)"
        [attr.data-testid]="testIds.inputUploadfile"
        style="display: none"
        accept=".png,.img,.jpg"
        type="file" />
    </div>
  </div>
</div>
